<template>
  <el-select v-model="mValue" size="mini" :placeholder="placeholder" v-bind="$attrs" class="vee-select">
    <el-option 
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"></el-option>
  </el-select>
</template>
<script>
import { Select, Option } from 'element-ui'

export default {
  components: {
    "ElSelect": Select,
    "ElOption": Option,
  },
  props: {
    value: {
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  computed: {
    mValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss">
.vee-select {
  &.el-select .el-input.is-disabled .el-input__inner {
    background: white;
    color: #606266;
  }
}
</style>
